<template>
  <div
    class="px-2"
    style="border: 1px solid var(--color-103)"
  />
</template>
